import React from 'react';

import FilterListIcon from '@mui/icons-material/FilterList';
import {
    Box,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    IconButton,
    Tooltip,
    Collapse,
    Card,
} from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { InputSearch, StatusFilterSelect } from 'common/components';

import { getUserOptions } from '../helpers';

const Filters = ({
    filterData,
    handleOnChangeSearch,
    handleOnSelectUser,
    handleOnSelectStatus,
    users,
    selectionModel,
}) => {
    const { t } = useTranslation();
    const [filterIsOpen, setFilterIsOpen] = React.useState(false);
    const toggleFilter = () => setFilterIsOpen((prev) => !prev);

    return (
        <Card>
            <Card.Body>
                <Box
                    sx={{ alignItems: 'center', display: 'flex', gap: 1 }}
                    size={{ lg: isEmpty(selectionModel) ? 12 : 8, xs: 18 }}
                >
                    <InputSearch
                        onChange={handleOnChangeSearch}
                        placeholder={t('Search contact')}
                        value={filterData?.searchText}
                    />
                    <Tooltip title={t('Filter', { count: 2 })}>
                        <IconButton onClick={toggleFilter}>
                            <FilterListIcon />
                        </IconButton>
                    </Tooltip>
                </Box>

                <Collapse in={filterIsOpen} sx={{ width: '100%' }}>
                    <Grid container mt={2}>
                        <Grid
                            size={{
                                lg: 4,
                                md: isEmpty(selectionModel) ? 9 : 6,
                                xs: 18,
                            }}
                        >
                            <FormControl fullWidth size="small">
                                <InputLabel>{t('Assigned to')}</InputLabel>
                                <Select
                                    label={t('Assigned to')}
                                    onChange={(e) =>
                                        handleOnSelectUser(e.target)
                                    }
                                    value={filterData?.userId}
                                    variant="outlined"
                                >
                                    {getUserOptions(users).map(
                                        ({ label, value, disabled }) => (
                                            <MenuItem
                                                disabled={disabled}
                                                key={`user-select-${value}-${label}`}
                                                value={value}
                                            >
                                                {label}
                                            </MenuItem>
                                        ),
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid
                            size={{
                                lg: 3,
                                md: isEmpty(selectionModel) ? 9 : 6,
                                xs: 18,
                            }}
                        >
                            <StatusFilterSelect
                                filterBy={filterData?.status}
                                handleSelected={handleOnSelectStatus}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </Collapse>
            </Card.Body>
        </Card>
    );
};

Filters.propTypes = {
    filterData: PropTypes.object,
    handleOnChangeSearch: PropTypes.func,
    handleOnSelectUser: PropTypes.func,
    handleOnSelectStatus: PropTypes.func,
    users: PropTypes.array,
    selectionModel: PropTypes.array,
};

export default Filters;
